import { render, staticRenderFns } from "./tanguo.vue?vue&type=template&id=2d01d434&scoped=true"
import script from "./tanguo.vue?vue&type=script&lang=js"
export * from "./tanguo.vue?vue&type=script&lang=js"
import style0 from "./tanguo.vue?vue&type=style&index=0&id=2d01d434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01d434",
  null
  
)

export default component.exports